module.exports = __webpack_public_path__ + "img/Menu-05.ce292f42.png";